import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { targetId: String };

  visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.element.classList.add('sign-call_scroll-button--hidden');
      } else if (entry.boundingClientRect.bottom >= 0) {
        this.element.classList.remove('sign-call_scroll-button--hidden');
      }
    });
  });

  connect() {
    this.visibilityObserver.observe(document.getElementById(this.targetIdValue));
  }

  disconnect() {
    this.visibilityObserver.unobserve(document.getElementById(this.targetIdValue));
  }

  scroll() {
    const targetPosition = document.getElementById(this.targetIdValue).offsetTop;
    const offset = 20;

    window.scrollTo({
      top: targetPosition - offset,
      behavior: 'smooth',
    });
  }
}
